@if (!(loadingTpl$|async) && !loading) {
  @if (previewVar && (templates$|async)?.[previewVar]) {
    <div class="preview-tamplate"
    [innerHtml]="(templates$|async)[previewTemplateVar || item[modeObj[mode]] || productPreviewVar[mode]] | replaceTokensArray: {keys: item, previewVar: previewTemplateVar || item[modeObj[mode]]} | safe: 'html'"></div>
  } @else {
    @if (item.FamilyName_s) {
      <div class="card card-item p-3" [ngClass]="{'': mode == 'list'}" [ngClass]="mode == 'list' ? 'flex-row w-100 list-card': 'grid-card'">
        <overlay-image split-char=", " style="z-index: 2" overlayImgUrlList="item.overlayImgUrl"
        overlayClassList="item.overlayClass"></overlay-image>
        @if (compareProduct) {
          @if (!comparePage) {
            <div class="compare-body">
              <div class="d-flex justify-content-between">
                <label>
                  <input type="checkbox"
                    [checked]="compare[item.product_id_i]"
                    (click)="addToCompare(item.product_id_i)">
                  @if (!compare[item?.product_id_i]) {
                    <span class="text-nowrap" translate>Mark to Compare</span>
                  } @else {
                    <span translate>Selected</span>
                  }
                </label>
                @if (compare[item?.product_id_i]) {
                  <div [routerLink]="['/catalogue/compare-products']"
                    class="compare-btn" translate>
                    <i class="fa fa-clone"></i>
                    <span class="link" translate>Compare Selected</span>
                  </div>
                }
              </div>
            </div>
          } @else {
            <button
              (click)="removeFromCompare(item?.product_id_i)"
              [routerLink]="['/catalogue/compare-products']"
              class="remove-btn-compare btn align-self-end"
              title="{{'Remove From Compare'|translate}}">
              <i class="material-icons">close</i>
            </button>
          }
        }
        @if (page=='favorites') {
          <add-to-favorite [productId]="[item.product_id_i]"></add-to-favorite>
        }
        <div class="card-images align-self-center" [ngClass]="{'h-50': mode == 'grid'}">
          <a [routerLink]="[item.getUrl()]">
            @if (!hideProductImageBox) {
              <img product-image
                [product]="item"
                [size]="'Med'"
                class="card-img-top img-responsive">
            }
            @if (imagePopularUrl) {
              <img [src]="imagePopularUrl"
                class="card-img-top img-responsive popular"
                alt="{{'Popular Image ' + item['popular_s']|translate}}">
            }
          </a>
        </div>
        <div class="body-footer-container d-flex" [ngClass]="mode == 'grid' ? 'h-50 flex-column' : 'flex-row w-100'">
          <div class="card-body d-flex p-0" [ngClass]="mode == 'grid' ? 'flex-column justify-content-end mb-4' : 'flex-row align-items-center justify-content-between'">
            <a [routerLink]="[item.getUrl()]">
              <div class="desc-prod" [ngClass]="{'d-flex gap-5 me-3 ms-0': mode == 'list'}">
                <span [ngClass]="{'d-none': mode == 'grid'}">{{item.product_code_s}}</span>
                <span [ngClass]="{'text-wrap': mode == 'list'}">{{item.ProductDescription_s}}</span>
              </div>
            </a>
            @if (!unCommerceApp && !commerceApp) {
              <span class="price-wrap d-flex fw-semibold" [ngClass]="mode == 'grid' ? 'mt-2' : 'me-3 ms-0'">
                <price [pid]="item.product_id_i"></price>
              </span>
            }
          </div>
          @if (item.not_buyable_s=='0') {
            <div class="card-footer border-top-0 bg-transparent p-0" [ngClass]="{'justify-content-center align-items-center d-flex': mode == 'list'}">
              @if (ProductType.isEcommerceType(item.productType)) {
                <add-to-cart [product]="item"></add-to-cart>
              }
            </div>
          }
        </div>
      </div>
    }
  }
}

